import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import PortalFeedback from "./components/PortalFeedback";
import { initSentry, Sentry } from "./utils/sentry";

initSentry();

function AppCrashFallback() {
  return (
    <div className="min-h-screen bg-[#f4f4f4] px-6 py-10">
      <div className="mx-auto max-w-xl">
        <PortalFeedback type="error">
          The portal hit an unexpected error. Refresh the page and try again.
        </PortalFeedback>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppCrashFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
